import React, { Fragment, useState, useEffect } from "react";
import {
  formatDate,
  EuiInMemoryTable,
  EuiSpacer,
  EuiAvatar,
  EuiBadge,
  EuiButton,
  EuiButtonIcon,
} from "@elastic/eui";
import OrganizationService from "../../services/organization-service";
import SendEmailTenantValidationsModal from "./SendEmailTenantValidationsModal.";
import OrganizationCreate from "./OrganizationCreate.";

const getDomainFromEmail = (email) => {
  if (!email || !email.includes("@")) return null;
  return email.split("@")[1].toLowerCase().trim();
};

const CompanyAvatar = ({ item }) => {
  const [logoError, setLogoError] = useState(false);

  const domain = getDomainFromEmail(item.mail);

  const logoUrl =
    domain && !logoError
      ? `https://img.logo.dev/${domain}?token=pk_VhKgHvyWSfinpEsvHMoLRw`
      : undefined;

  return (
    <EuiAvatar
      size="s"
      name={item.nameLong || "Company"}
      imageUrl={logoUrl}
      imageProps={{
        onError: () => setLogoError(true),
      }}
    />
  );
};

export const OrganizationTable = (props) => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isClosed, setIsClosed] = useState(true);

  const toggleIsClosed = () => setIsClosed((prevState) => !prevState);

  const permissionsBadge = (item) => {
    const permissions = item.permissions;
    if (permissions === "validated") {
      return (
        <>
          <EuiBadge color="success">{permissions}</EuiBadge>
        </>
      );
    } else if (permissions === "revoked") {
      return (
        <>
          <EuiBadge color="danger">{permissions}</EuiBadge>
          &nbsp;
          <SendEmailTenantValidationsModal item={item} />
        </>
      );
    } else if (permissions === "pending_validate") {
      return (
        <>
          <EuiBadge color="warning">{permissions}</EuiBadge>
          &nbsp;
          <SendEmailTenantValidationsModal item={item} />
        </>
      );
    } else {
      return (
        <>
          <EuiBadge color="primary">{permissions}</EuiBadge>
          &nbsp;
          <SendEmailTenantValidationsModal item={item} />
        </>
      );
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("krakenT");
    OrganizationService.getOrganizations(token)
      .then((response) => {
        const companies = [];
        for (let company of response.data.message) {
          companies.push(company);
        }
        setCompanies(companies);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }, [isClosed]);

  const companyClicked = (item) => {
    props.companySelected(item);
  };
  const actions = [
    {
      name: "Edit",
      description: "Edit",
      icon: "indexEdit",
      type: "icon",
      onClick: (item) => companyClicked(item),
    },
  ];

  const columns = [
    {
      name: "",
      actions,
      width: 30,
    },
    {
      name: "Name",
      render: (item) => (
        <>
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CompanyAvatar item={item} />
            <span>{item.nameLong}</span>
          </span>
        </>
      ),
      width: 300,
      truncateText: true,
    },
    {
      name: "Tenant Permissions",
      render: (item) => permissionsBadge(item),
      sortable: true,
      width: 250,
    },
    {
      field: "companyCode",
      name: "Company Code",
      sortable: true,
      truncateText: true,
    },
    {
      field: "cif",
      name: "CIF",
      sortable: true,
      truncateText: true,
    },
    {
      field: "contact",
      name: "Contact",
      sortable: true,
      truncateText: true,
    },

    {
      field: "mail",
      name: "Mail",
      sortable: true,
      truncateText: true,
    },
    {
      field: "phone",
      name: "Phone",
      sortable: true,
      truncateText: true,
    },
    {
      field: "createdAt",
      name: "Date Creation",
      dataType: "date",
      render: (date) => formatDate(date, "dobLong"),
      sortable: true,
      truncateText: true,
    },
    {
      field: "updatedAt",
      name: "Last Update",
      dataType: "date",
      render: (date) => formatDate(date, "dobLong"),
      sortable: true,
      truncateText: true,
    },
    {
      field: "status",
      name: "Status",
      render: (status) => <EuiBadge color="success">{status}</EuiBadge>,
      truncateText: true,
    },
  ];

  const search = {
    box: {
      incremental: true,
      schema: true,
    },
  };

  return (
    <Fragment>
      <OrganizationCreate closeModalProp={toggleIsClosed} />
      <EuiSpacer size="l" />
      <EuiInMemoryTable
        message={loading ? "Loading ..." : "No items found"}
        loading={loading}
        tableCaption="Demo of EuiInMemoryTable with search"
        items={companies}
        columns={columns}
        search={search}
        pagination={{
          pageSizeOptions: [5, 10, 11],
          initialPageSize: 11, // Tamaño de página inicial
        }}
        sorting={true}
      />
    </Fragment>
  );
};